import React, {useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as actions from '../actions/project';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Chip from '@material-ui/core/Chip';
import Container from '@material-ui/core/Container';
import {ButtonDeleteChart} from '../components'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {ChangeChartTitle} from '../components'
import {ErrcEd} from '../components/edComponents';
import {ErrcEdEnglish} from '../components/edComponents';
import {EdModal} from '../components/edComponents';
import {Insights} from '../components'
import Tooltip from '@material-ui/core/Tooltip';
import Zoom from '@material-ui/core/Zoom';


const useStyles = makeStyles(theme => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        outline: 'none'
    },
    paper: {
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #000',
        boxShadow: theme.shadows[2],
        padding: theme.spacing(2, 4, 3),
        outline: 'none'
    },
    form: {
        '& > *': {
            margin: theme.spacing(1),
            width: '100%',
        },
    },
    buttonmodal: {
      'margin-right': '15px',
    },
    buttonmodaldelete: {
      float: 'right',
      'margin-right': '15px',
      color: '#ff3d00'
    },
    grid: {
      'padding-top': '15px',
    },
    gridcolumn: {
    },
    errc: {
      padding: '20px',
      background: 'white',
      boxShadow: theme.shadows[1],
      minHeight: '300px',

    },
    errcHead: {
      display: 'flex',
      'justify-content': 'space-between'
    },
    p: {
      'font-size': '12px'
    },
    li: {
      display: 'inline',
    },
    container: {
      float: 'left'
    },
    Chip: {
      margin: '5px'
    },
    buttonDelete: {
      float: 'right',
    },
    Button: {
      background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7)'
    },
    h1: {
      display: 'inline'
    },
    head: {
      display: 'flex',
    },
    Tooltip: {
      maxWidth: 500,
      fontSize: '16px'
    }

}));

const grid = 8;
const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: 'none',
    // boxShadow: isDragging ? '10px 10px 32px -5px rgba(0,0,0,0.25)' : 'none',

    // styles we need to apply on draggables
    ...draggableStyle,
});
const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? '#e1f5fe' : 'none',
    minHeight: '100px',
    display: 'flex',
    // padding: grid,
    overflow: 'hidden',
    flexWrap: 'wrap'
});
const reorder = (list, startIndex, endIndex, NewDroppableId) => {
    const result = Array.from(list);
    // // console.log(result, 'result', startIndex, endIndex, NewDroppableId)
    // result[startIndex]['type'] = NewDroppableId
    const [removed] = result.splice(startIndex, 1);
    removed['type'] = parseInt(NewDroppableId)
    // // console.log(removed, 'removed')
    result.splice(endIndex, 0, removed);

    return result;
};


function ERRCDetail({getAllStrategyMap, strategyMapList, updateChart, selected, getDetailChart, match: {params: {projectId, chartId}}}) {
    React.useEffect(() => {
        getDetailChart(projectId, chartId)
        getAllStrategyMap(projectId)
    }, [projectId, chartId]);

    const [open, setOpen] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState(false);
    const [openImport, setOpenImport] = React.useState(false);
    const [openUpdate, setOpenUpdate] = React.useState(false);
    const [type, setType] = React.useState({
      type: null
    });
    const [keys, setKeys] = React.useState({
      key: null
    });

    const classes = useStyles();

    const [values, setValues] = React.useState({
        title: [],
        description: [],
        type: [],
        id: []
    });

    React.useEffect(
        () => {
            if (!selected) {
                return
            }
            setValues({...values, data: selected.data});
        }, [selected]
    );

    if (!selected) {
        return (
            <div>
                Not Found
            </div>
        )
    }

    var id = 0
    const handleClick = event => {
        const newData = [...selected.data];
        newData.push({
          'title': values.title,
          'description': values.description,
          'type': type,
        })

        newData.forEach((item, i) => {
          item.id = i+'_item'
        });

        // // console.log('newdata')
        // // console.log(newData)

        setValues({data: newData});
        updateChart(projectId, chartId, {...selected, data: newData});
        setOpen(false);
    };

    const handleClickUpdate = event => {

      // // console.log([...selected.data][keys.key])
      console.log(values, 'values')
      const newData = {
        'title': values.title.length === 0 ? selected.data[keys.key].title : values.title,
        'description': values.description.length === 0 ? selected.data[keys.key].description : values.description,
        'type': selected.data[keys.key].type,
        'id': selected.data[keys.key].id
      }
      selected.data[keys.key] = newData
      // // console.log([...selected.data][keys.key])

      updateChart(projectId, chartId, {...selected, data: selected.data})
      setOpenUpdate(false)
      setValues({
        title: [],
        description: [],
        type: [],
        id: []
      })
    }

    const handleChange = name => event => {
        setValues({...values, [name]: event.target.value});
    };

    const clickAddFactor = (key) => {
      setType(key)
      setOpen(true)
    }

    const chipClickModal = (key) => {
      setOpenUpdate(true)

      setKeys({
        'key': key
      })
    }

    const chipClickDelete = event => {
      // // {// console.log(event)}
      const newData = [...selected.data]

      newData.splice(event,1)
      // // {// console.log(newData)}
      setValues({data: newData})
      updateChart(projectId, chartId, {...selected, data: newData})
      setOpenUpdate(false)
    }

    const chooseImport = (key) => {
      // // console.log(key)
      const newData = [...selected.data];
      // // console.log(strategyMapList[key].data.data)
      strategyMapList[key].data.data.forEach((item, i) => {
        // // console.log(item.title)
        newData.push({
          'title': item.title,
          'description': '',
          'type': 0,
        })
      });

      newData.forEach((item, i) => {
        item.id = i+'_item'
      });

      setValues({data: newData});
      updateChart(projectId, chartId, {...selected, data: newData, insights: strategyMapList[key].insights});
      setAnchorEl(false);
      setOpenImport(false);
      window.location.reload(false);
    }



    const handleClickMenu = event => {
      setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = event => {
      setAnchorEl(false);
    }


    const onDragEnd = result => {
      const { source, destination } = result;
      // // console.log('onDragEnd', result)
      if (destination != null) {
        const newData = reorder(
                  selected.data,
                  source.index,
                  destination.index,
                  destination.droppableId
              );
              // // console.log('items',newData)
              setValues({data: newData});
              updateChart(projectId, chartId, {...selected, data: newData})
      }
    }



    return (
        <>
        <Container
          maxWidth="lg"
          className={classes.container}
          >
          <div
            className={classes.head}>
            <ChangeChartTitle
              selected={selected}
              projectId={projectId}
              chartId={chartId}
              title={<h1
                className={classes.h1}>ERRC | {selected.title} </h1>}/>
            <EdModal
              TextRu={ErrcEd}
              TextEng={ErrcEdEnglish}/>
          </div>
            <Button
              className={classes.Button}
              variant="contained"
              color="primary"
              style={{
                background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
              onClick={() => setOpenImport(true)}
            >
                import Keys
            </Button>
              <Modal
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                  className={classes.modal}
                  open={openImport}
                  disableAutoFocus={true}
                  onClose={() => setOpenImport(false)}
              >
                    <div className={classes.paper}>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleClickMenu}
                          style={{
                            background: 'linear-gradient(45deg, #1c7ff4 30%, #45adf7'}}
                          className={classes.Button}
                          >
                          CHOOSE AS-IS Strategy Canvas
                        </Button>
                        <Menu
                          id="simple-menu"
                          anchorEl={anchorEl}
                          keepMounted
                          open={Boolean(anchorEl)}
                          onClose={() => handleCloseMenu()}
                        >
                          {Object.values(strategyMapList).map((item, index) => (
                            <div
                              key={(toString(index)+'modalnew')}>
                              <MenuItem
                                key={(toString(index)+'modalnew')}
                                onClick={() => chooseImport(index)}>
                                  {item.title}
                              </MenuItem>
                            </div>
                          ))}


                        </Menu>
                    </div>
              </Modal>

          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable
              droppableId="0"
              direction="horizontal">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    style={getListStyle(snapshot.isDraggingOver)}>
                            {Object.values(selected.data).map(
                              (obj, key) =>(
                                <div
                                  key={obj.id}>
                                  {obj.type === 0 &&
                                    <Draggable
                                        key={obj.id}
                                        draggableId={obj.id}
                                        index={key}
                                    >
                                        {(provided, snapshot) => (
                                          <div
                                              key={obj.id}
                                              ref={provided.innerRef}
                                              {...provided.draggableProps}
                                              {...provided.dragHandleProps}
                                              style={getItemStyle(
                                                    snapshot.isDragging,
                                                    provided.draggableProps.style
                                              )}
                                          >
                                              <div className={classes.li}
                                                key={key}>
                                                    <div
                                                      key={key}
                                                      className={classes.li}
                                                      >
                                                        <Chip
                                                          key={key}
                                                          className={classes.Chip}
                                                          label={obj.title}
                                                          component="a"
                                                          clickable
                                                          onClick={() => chipClickModal(key)}/>
                                                    </div>

                                            </div>
                                          </div>
                                        )}
                                    </Draggable>
                                  }
                                </div>
                            ))}
                      {provided.placeholder}
                  </div>
                )}
            </Droppable>


          <Grid
            container spacing={2}
            className={classes.grid}
          >
                      <Grid
                        item xs={6}
                        className={classes.gridcolumn}>
                      <div
                        className={classes.errc}>
                          <div
                              className={classes.errcHead}>
                                <h2>Eliminate</h2>
                              <Button
                                variant="outlined"
                                color="primary"
                                onClick={() => clickAddFactor(1)}
                              >+ Add keys Factor
                              </Button>
                          </div>
                          <p
                            className={classes.p}>
                              Which factors that the industry has long competed on and invested in should be eliminated? Consider the factors which you find to be irrelevant through the six paths exploration.
                          </p>
                          <div>
                            <Droppable
                              droppableId="1"
                              direction="horizontal"
                              >
                                {(provided, snapshot) => (
                                  <div

                                    ref={provided.innerRef}
                                    style={getListStyle(snapshot.isDraggingOver)}>
                                            {Object.values(selected.data).map(
                                              (obj, key) =>(
                                                <div
                                                  key={obj.id}>
                                                  {obj.type === 1 &&
                                                    <Draggable
                                                        key={obj.id}
                                                        draggableId={obj.id}
                                                        index={key}
                                                    >
                                                        {(provided, snapshot) => (
                                                          <div
                                                              ref={provided.innerRef}
                                                              {...provided.draggableProps}
                                                              {...provided.dragHandleProps}
                                                              style={getItemStyle(
                                                                    snapshot.isDragging,
                                                                    provided.draggableProps.style
                                                              )}
                                                          >
                                                            <div
                                                              key={key}
                                                              className={classes.li}>

                                                                    <div
                                                                      key={key}
                                                                      className={classes.li}
                                                                      >
                                                                      <Tooltip
                                                                        title={obj.description == null ? "" : obj.description}
                                                                        TransitionComponent={Zoom}
                                                                        interactive
                                                                        placement="top"
                                                                        arrow
                                                                        classes={{ tooltip: classes.Tooltip }}>

                                                                          <Chip
                                                                            key={key}
                                                                            className={classes.Chip}
                                                                            label={obj.title}
                                                                            component="a"
                                                                            clickable
                                                                            onClick={() => chipClickModal(key)}/>

                                                                      </Tooltip>
                                                                    </div>

                                                            </div>
                                                          </div>
                                                        )}
                                                    </Draggable>
                                                  }
                                                </div>
                                            ))}
                                      {provided.placeholder}
                                  </div>
                                )}
                            </Droppable>
                          </div>
                        </div>
                    </Grid>


                <Grid
                  item xs={6}
                  className={classes.gridcolumn}>
                <div
                  className={classes.errc}>
                    <div
                        className={classes.errcHead}>
                        <h2>Raise</h2>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => clickAddFactor(2)}
                        >+ Add keys Factor
                        </Button>
                    </div>
                    <p
                      className={classes.p}>
                      Which factors should be raised well above the industry's standard? Consider the compromises that buyers are forced to make.

                    </p>
                    <div>
                      <Droppable
                        droppableId="2"
                        direction="horizontal">
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                                      {Object.values(selected.data).map(
                                        (obj, key) =>(
                                          <div
                                            key={obj.id}>
                                            {obj.type === 2 &&
                                              <Draggable
                                                  key={obj.id}
                                                  draggableId={obj.id}
                                                  index={key}
                                              >
                                                  {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                              snapshot.isDragging,
                                                              provided.draggableProps.style
                                                        )}
                                                    >
                                                      <div
                                                        key={key}
                                                        className={classes.li}>

                                                              <div
                                                                key={key}
                                                                className={classes.li}
                                                                >
                                                                <Tooltip
                                                                  title={obj.description == null ? "" : obj.description}
                                                                  TransitionComponent={Zoom}
                                                                  interactive
                                                                  placement="top"
                                                                  arrow
                                                                  classes={{ tooltip: classes.Tooltip }}>
                                                                    <Chip
                                                                      key={key}
                                                                      className={classes.Chip}
                                                                      label={obj.title}
                                                                      component="a"
                                                                      clickable
                                                                      onClick={() => chipClickModal(key)}/>
                                                                </Tooltip>
                                                              </div>

                                                      </div>
                                                    </div>
                                                  )}
                                              </Draggable>
                                            }
                                          </div>
                                      ))}
                                {provided.placeholder}
                            </div>
                          )}
                      </Droppable>
                    </div>
                  </div>
                </Grid>

                <Grid
                  item xs={6}
                  className={classes.gridcolumn}>
                <div
                  className={classes.errc}>
                    <div
                        className={classes.errcHead}>
                        <h2>Reduce</h2>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => clickAddFactor(3)}
                        >+ Add keys Factor
                        </Button>
                    </div>
                    <p
                      className={classes.p}>
                      Which factors should be reduced well below the industry's standard? Consider the factors that have been overdesigned in the race to match and beat the competition.
                    </p>
                    <div>
                      <Droppable
                        droppableId="3"
                        direction="horizontal">
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                                      {Object.values(selected.data).map(
                                        (obj, key) =>(
                                          <div
                                            key={obj.id}>
                                            {obj.type === 3 &&
                                              <Draggable
                                                  key={obj.id}
                                                  draggableId={obj.id}
                                                  index={key}
                                              >
                                                  {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                              snapshot.isDragging,
                                                              provided.draggableProps.style
                                                        )}
                                                    >
                                                      <div
                                                        key={key}
                                                        className={classes.li}>

                                                              <div
                                                                key={key}
                                                                className={classes.li}
                                                                >
                                                                <Tooltip
                                                                  title={obj.description == null ? "" : obj.description}
                                                                  TransitionComponent={Zoom}
                                                                  interactive
                                                                  placement="top"
                                                                  arrow
                                                                  classes={{ tooltip: classes.Tooltip }}>
                                                                    <Chip
                                                                      key={key}
                                                                      className={classes.Chip}
                                                                      label={obj.title}
                                                                      component="a"
                                                                      clickable
                                                                      onClick={() => chipClickModal(key)}/>
                                                                  </Tooltip>
                                                              </div>

                                                      </div>
                                                    </div>
                                                  )}
                                              </Draggable>
                                            }
                                          </div>
                                      ))}
                                {provided.placeholder}
                            </div>
                          )}
                      </Droppable>
                    </div>
                  </div>
                </Grid>

                <Grid
                  item xs={6}
                  className={classes.gridcolumn}>
                <div
                  className={classes.errc}>
                    <div
                        className={classes.errcHead}>
                        <h2>Create</h2>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={() => clickAddFactor(4)}
                        >+ Add keys Factor
                        </Button>
                    </div>
                    <p
                      className={classes.p}>
                      Which factors should be created that the industry has never offered? Consider the factors that will offer entirely new kinds of value for buyers and convert noncustomers into customers.
                    </p>
                    <div>
                      <Droppable
                        droppableId="4"
                        direction="horizontal">
                          {(provided, snapshot) => (
                            <div
                              ref={provided.innerRef}
                              style={getListStyle(snapshot.isDraggingOver)}>
                                      {Object.values(selected.data).map(
                                        (obj, key) =>(
                                          <div
                                            key={obj.id}>
                                            {obj.type === 4 &&
                                              <Draggable
                                                  key={obj.id}
                                                  draggableId={obj.id}
                                                  index={key}
                                              >
                                                  {(provided, snapshot) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        {...provided.dragHandleProps}
                                                        style={getItemStyle(
                                                              snapshot.isDragging,
                                                              provided.draggableProps.style
                                                        )}
                                                    >
                                                      <div
                                                        key={key}
                                                        className={classes.li}>

                                                              <div
                                                                key={key}
                                                                className={classes.li}
                                                                >
                                                                <Tooltip
                                                                  title={obj.description == null ? "" : obj.description}
                                                                  TransitionComponent={Zoom}
                                                                  interactive
                                                                  placement="top"
                                                                  arrow
                                                                  classes={{ tooltip: classes.Tooltip }}>
                                                                    <Chip
                                                                      key={key}
                                                                      className={classes.Chip}
                                                                      label={obj.title}
                                                                      component="a"
                                                                      clickable
                                                                      onClick={() => chipClickModal(key)}/>
                                                                </Tooltip>
                                                              </div>

                                                      </div>
                                                    </div>
                                                  )}
                                              </Draggable>
                                            }
                                          </div>
                                      ))}
                                {provided.placeholder}
                            </div>
                          )}
                      </Droppable>
                    </div>
                  </div>
                </Grid>

          </Grid>
        </DragDropContext>




          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={open}
            disableAutoFocus={true}
            onClose={() => setOpen(false)}>
              <div className={classes.paper}>
                <form
                    className={classes.form}
                    noValidate autoComplete="off">
                    <TextField
                        id="title"
                        label="Name"
                        value={values.title}
                        onChange={handleChange('title')}/>
                    <TextField
                        id="description"
                        multiline
                        label="Description"
                        value={values.description}
                        onChange={handleChange('description')}/>
                    <Button
                        className={classes.Button}
                        variant="contained"
                        color="primary"
                        onClick={() => handleClick()}>
                        + add
                    </Button>
                </form>
              </div>

          </Modal>

          <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            className={classes.modal}
            open={openUpdate}
            disableAutoFocus={true}
            onClose={() => setOpenUpdate(false)}>
            <div>
              {selected.data[keys.key] && <>
                <h4></h4>
                <div className={classes.paper}>
                  <form
                      className={classes.form}
                      noValidate autoComplete="off">
                      <TextField
                          id="title"
                          label="Name"
                          defaultValue={selected.data[keys.key].title}
                          onChange={handleChange('title')}/>
                      <TextField
                          id="description"
                          multiline
                          label="Description"
                          defaultValue={selected.data[keys.key].description}
                          onChange={handleChange('description')}/>
                      </form>
                      <br/>
                      <Button
                          className={classes.Button}
                          variant="contained"
                          color="primary"
                          onClick={() => handleClickUpdate()}>
                          update
                      </Button>
                      <Button
                        variant="outlined"
                        color="secondary"
                        className={classes.buttonDelete}
                        onClick={() => chipClickDelete(keys.key)}
                      >
                          Delete
                      </Button>
                </div>

                </>
            }
            </div>
          </Modal>

          <Insights
            selected={selected}
            projectId={projectId}
            chartId={chartId}
          />







          </Container>








        </>
    )
}

const mapStateToProps = state => ({...state.charts, strategyMapList: state.strategyMap.data});
const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps, mapDispatchToProps,
)(ERRCDetail)
